
import TableList from "@components/templates/tablelist";
import { HttpWorkManageList } from "@/service/workorder";
import { mapGetters } from "vuex";
import mixin from './mixin'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpWorkManageList,
        handleOperates(params) {
            this.$emit('on-data', params)
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList']),
        SearchsData() {
            return [
                {
                    label: "事务处理计划单号",
                    tag: 'vInput',
                    key: 'EQ_workOrderPlanNo',
                    show: true,
                },
                {
                    label: "来源单号",
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                },
                {
                    label: "关联单据类型",
                    tag: 'vSelect',
                    key: 'EQ_relationOrderTypeId',
                    options: this.getRelativeOrderTypes,
                    show: true,
                    // props: {
                    //     filterable: true,
                    // },
                },
                {
                    label: "关联单据号",
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                    show: true,
                },
            ]
        },
        columns() {
            return [{
                title: '事务处理计划单号',
                key: "workOrderPlanNo",
            },
            {
                title: '来源单号',
                key: 'sourceNo',
            },
            {
                title: '关联单据类型',
                key: 'relationOrderTypeId',
                render: (h, { row }) => this.findRenderLabel(this.getRelativeOrderTypes, row.relationOrderTypeId),
            },
            {
                title: '关联单据号',
                key: 'orderNo',
            },
            {
                title: '仓库',
                key: 'orgWarehouseId',
                render: (h, { row }) => {
                    return <div>{row.orgWarehouseCode} ({row.orgWarehouseTitle})</div>
                },
            },
            {
                title: '操作',
                render: (h, { row }) => {
                    return <vButton theme="primary" nativeOnClick={this.handleOperates.bind(this, row)}>选择</vButton>
                }
            }
            ];
        },

    },

};
